import { useCallback, useContext } from 'react';
import {
  useActionItem,
  ActionItemOperation as Operation,
  AiContext,
} from '@workboard/action-item';

export function useGiveBadge(aiId: string | null, analyticName: string | null = null) {
  const { setDisabledEnforceFocus } = useContext(AiContext);
  const { isPermitted, actionItem, refetch } = useActionItem(aiId);
  const canGiveBadge = isPermitted(Operation.giveBadge);

  const teamId = actionItem?.workstreamContext?.workstream?.team?.id ?? '';

  const onOpen = useCallback(() => {
    setDisabledEnforceFocus(true);
  }, [setDisabledEnforceFocus]);

  const onClose = useCallback(() => {
    setDisabledEnforceFocus(false);
    refetch();
  }, [setDisabledEnforceFocus, refetch]);

  const giveBadge = useCallback(() => {
    onOpen();
    window.sendBadgeFun(
      teamId,
      actionItem?.assignee?.id,
      aiId,
      undefined,
      undefined,
      onClose,
      null,
      analyticName
    );
  }, [aiId, teamId, actionItem?.assignee?.id, onOpen, onClose, analyticName]);

  return [canGiveBadge, giveBadge] as const;
}
